import { plural } from '@cian/utils';
import { createSelector } from '@reduxjs/toolkit';

import { selectWorkplaceCount } from 'shared/selectors/jsonQuery';

const DEFAULT_LABEL = 'Кол-во мест';

const format = (value: number) => value.toLocaleString('ru-RU');

export const selectWorkplaceCountLabel = createSelector(selectWorkplaceCount, ({ gte, lte }) => {
  const min = typeof gte === 'number' ? gte : null;
  const max = typeof lte === 'number' ? lte : null;

  if (min !== null && max !== null) {
    return `${format(min)} - ${format(max)} ${plural(max, ['место', 'места', 'мест'])}`;
  }

  if (min !== null) {
    return `от ${format(min)} ${plural(min, ['места', 'мест', 'мест'])}`;
  }

  if (max !== null) {
    return `до ${format(max)} ${plural(max, ['места', 'мест', 'мест'])}`;
  }

  return DEFAULT_LABEL;
});
